<template>
  <v-container fluid :loading="loading" class="chart-container pa-0">
    <v-progress-linear
      :active="downloading"
      :indeterminate="downloading"
      color="red"
    />
    <v-row>
      <div style="margin: 0 0 0 auto">
        <v-btn @click="downloadDetectionReport">
          時系列データ ダウンロード
        </v-btn>
      </div>
    </v-row>

    <v-row>
      <div class="detect-stats-row">
        <div class="detect-stats-icon">
          <v-icon x-large class="pt-2" style="font-size: 72px">
            mdi-walk
          </v-icon>
        </div>
        <div class="detect-stats-summary">
          <!-- <v-progress-linear
            :active="summaryLoading"
            :indeterminate="summaryLoading"
            color="#25BCD4"
          /> -->
          <h1>通過: {{ summary.current.pass }}</h1>
          <h4 class="text--secondary summary-description">
            前を通った人
          </h4>
          <h3>
            前期比:
            {{ getPreviousRatio(summary.current.pass, summary.previous.pass) }}
            %
          </h3>
        </div>
        <div class="detect-stats-chart" :key="passChartKey">
          <!-- <v-progress-linear
            :active="detectionLoading"
            :indeterminate="detectionLoading"
            color="#25BCD4"
          /> -->
          <apex-chart
            type="bar"
            height="150"
            :options="stats.pass.chart.options"
            :series="stats.pass.chart.series"
          ></apex-chart>
        </div>
      </div>
    </v-row>

    <v-row>
      <div class="detect-stats-row">
        <div class="detect-stats-icon">
          <v-icon x-large class="pt-2" style="font-size: 72px">
            mdi-eye
          </v-icon>
        </div>
        <div class="detect-stats-summary">
          <h1>視認: {{ summary.current.look }}</h1>
          <h4 class="text--secondary summary-description">
            一瞬でも顔を向けた人
          </h4>
          <h3>
            前期比:
            {{ getPreviousRatio(summary.current.look, summary.previous.look) }}
            %
          </h3>
        </div>
        <div class="detect-stats-chart" :key="lookChartKey">
          <apex-chart
            type="bar"
            height="150"
            :options="stats.look.chart.options"
            :series="stats.look.chart.series"
          ></apex-chart>
        </div>
      </div>
    </v-row>

    <v-row>
      <div class="detect-stats-row">
        <div class="detect-stats-icon">
          <v-icon x-large class="pt-2" style="font-size: 72px">
            mdi-account-alert
          </v-icon>
        </div>
        <div class="detect-stats-summary">
          <h1>興味: {{ summary.current.interest }}</h1>
          <h4 class="text--secondary summary-description">
            視認＋５秒以上留まった人
          </h4>
          <h3>
            前期比:
            {{
              getPreviousRatio(
                summary.current.interest,
                summary.previous.interest
              )
            }}
            %
          </h3>
        </div>
        <div class="detect-stats-chart" :key="interestChartKey">
          <apex-chart
            ref="lineChart"
            type="bar"
            height="150"
            :options="stats.interest.chart.options"
            :series="stats.interest.chart.series"
          ></apex-chart>
        </div>
      </div>
    </v-row>

    <v-row>
      <div class="detect-stats-row">
        <div class="detect-stats-icon">
          <v-icon x-large class="pt-2" style="font-size: 72px">
            mdi-image-filter-center-focus
          </v-icon>
        </div>
        <div class="detect-stats-summary">
          <h1>注視: {{ summary.current.focus }}</h1>
          <h4 class="text--secondary summary-description">
            ２秒以上続けて顔を向けた人
          </h4>
          <h3>
            前期比:
            {{
              getPreviousRatio(summary.current.focus, summary.previous.focus)
            }}
            %
          </h3>
        </div>
        <div class="detect-stats-chart" :key="focusChartKey">
          <apex-chart
            type="bar"
            height="150"
            :options="stats.focus.chart.options"
            :series="stats.focus.chart.series"
          ></apex-chart>
        </div>
      </div>
    </v-row>

    <v-row>
      <div class="detect-stats-row">
        <div class="detect-stats-icon">
          <v-icon x-large class="pt-2" style="font-size: 72px">
            mdi-cursor-pointer
          </v-icon>
        </div>
        <div class="detect-stats-summary">
          <h1>タッチ: {{ summary.current.touch }}</h1>
          <h4 class="text--secondary summary-description">
            商品を触った人
          </h4>
          <h3>
            前期比:
            {{
              getPreviousRatio(summary.current.touch, summary.previous.touch)
            }}
            %
          </h3>
        </div>
        <div class="detect-stats-chart" :key="touchChartKey">
          <apex-chart
            type="bar"
            height="150"
            :options="stats.touch.chart.options"
            :series="stats.touch.chart.series"
          />
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { Pick } from '@/protocol'
import { functions } from '@/config/firebase'
import { reportFunctionsMixin, downloadFunctionsMixin } from '@/plugins/mixins'
import { mapActions } from 'vuex'
import apexChart from 'vue-apexcharts'
import { getReportDetailsWithinByUnixtime } from '@/firebaseAccess/firestoreAccess'
import { fmt } from '@/plugins/datefns'
import {
  addDays,
  subDays,
  differenceInDays,
  endOfDay,
  startOfDay
} from 'date-fns/esm'

const formatDate = timeStamp => {
  return fmt(timeStamp, 'yyyy/MM/dd HH:mm')
}

const detectionTimeLine = {
  stepLength: 0,
  values: []
}

const chartIds = {
  unknown: 'unknown',
  pass: 'pc',
  look: 'lc',
  interest: 'ic',
  focus: 'fc',
  touch: 'tc'
}

const baseChartOptions = id => {
  return {
    chart: {
      id: id,
      // group: 'detectionChart',
      type: 'bar',
      // width: '100%',
      stacked: false,
      toolbar: {
        show: true,
        autoSelected: 'pan',
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true
        }
      }
    },
    forceNiceScale: true,
    stroke: {
      show: false
      // width: 0
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left'
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%'
      }
    },
    xaxis: {
      title: {
        text: '時間',
        offsetY: 8
      },
      type: 'category',
      // type: 'datetime',
      // labels: {
      //   datetimeUTC: false
      // },
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      title: {
        text: '人数'
      },
      labels: {
        formatter: value => {
          return Math.ceil(value)
        }
      },
      tickAmount: 5
    },
    tooltip: {
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        const dateTimestamp = detectionTimeLine.values[dataPointIndex]
        const stepDateTimestamp =
          dateTimestamp + detectionTimeLine.stepLength - 1

        const eventDate = formatDate(dateTimestamp)
        const stepDate = formatDate(stepDateTimestamp)
        const eventName = w.globals.seriesNames[0]
        return (
          '<div style="text-align: center;width: 120px;">' +
          '<div style="background: #e5e5e5;">' +
          '<div>' +
          eventDate +
          '</div>' +
          '<div style="line-height: 0.6;">' +
          ' ~ ' +
          '</div>' +
          '<div>' +
          stepDate +
          '</div>' +
          '</div>' +
          '<div style="background: #ffffff;line-height: 3.0;">' +
          eventName +
          ': ' +
          series[seriesIndex][dataPointIndex] +
          '</div>' +
          '</div>'
        )
      }
      // x: {
      //   format: 'yyyy/MM/dd HH:mm'
      // }
    },
    animations: {
      enabled: false,
      animateGradually: {
        enabled: false
      },
      dynamicAnimation: {
        enabled: false
      }
    }
  }
}

const eventModel = chartId => {
  return {
    chart: {
      series: [],
      options: baseChartOptions(chartId)
    }
  }
}

const statsModel = () => {
  return {
    pass: eventModel(chartIds.pass),
    look: eventModel(chartIds.look),
    interest: eventModel(chartIds.interest),
    focus: eventModel(chartIds.focus),
    touch: eventModel(chartIds.touch)
  }
}

const summaryModel = () => {
  return {
    pass: 0,
    look: 0,
    interest: 0,
    focus: 0,
    touch: 0
  }
}

const xaxisCategories = (division, firstDate, lastDate) => {
  let category = []
  switch (division) {
    case 'hours':
      category = [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00'
      ]
      break
    case 'days': {
      const diffDays = differenceInDays(lastDate, firstDate) + 1
      const days = [firstDate]
      for (let i = 1; i < diffDays; i++) {
        days.push(addDays(days[i - 1], 1))
      }
      category = days.map(d => fmt(d, 'MM/dd'))
      break
    }
  }

  return category
}

export default {
  name: 'DetectionChart',
  mixins: [reportFunctionsMixin, downloadFunctionsMixin],
  props: {
    filters: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  components: {
    apexChart
  },
  data() {
    return {
      stats: statsModel(),
      summary: {
        current: summaryModel(),
        previous: summaryModel()
      },
      summaryLoading: false,
      detectionLoading: false,
      passChartKey: 0,
      lookChartKey: 0,
      interestChartKey: 0,
      focusChartKey: 0,
      touchChartKey: 0,
      downloading: false
    }
  },
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack'
    }),
    getPreviousRatio(current, previous) {
      if (current && previous) {
        if (previous !== 0) {
          return Math.round((current / previous) * 100)
        }

        return 0
      }

      return '--'
    },
    async getReports(devices, from, to) {
      // Convert Date data into unixtime second(not milli second).
      const fromSeconds = Math.floor(from.getTime() / 1000)
      const toSeconds = Math.floor(to.getTime() / 1000)

      const reports = []
      for (const deviceId of devices) {
        const reportRefs = await getReportDetailsWithinByUnixtime(
          deviceId,
          Pick.Report.ReportInfo.Type.TYPE_DETECTION,
          fromSeconds,
          toSeconds
        )

        for (const doc of reportRefs.docs) {
          reports.push(doc.data())
        }
      }

      return reports
    },
    async updateReport(devices, startDate, endDate) {
      const reports = await this.getReports(devices, startDate, endDate)

      const diffDays = differenceInDays(endDate, startDate) + 1

      const timeStep = diffDays == 1 ? 'hours' : 'days'
      await this.updateCharts(reports, startDate, endDate, timeStep)

      const previousStartDate = subDays(startDate, diffDays)
      const previousEndDate = subDays(endDate, diffDays)

      const previousReports = await this.getReports(
        devices,
        previousStartDate,
        previousEndDate
      )

      const current = summaryModel()
      for (const report of reports) {
        for (const key in report.data) {
          if (report.data[key] !== null) {
            current[key] += report.data[key].y
          }
        }
      }

      const previous = summaryModel()
      for (const previousReport of previousReports) {
        for (const key in previousReport.data) {
          if (previousReport.data[key] !== null) {
            previous[key] += previousReport.data[key].y
          }
        }
      }

      this.summary.current = current
      this.summary.previous = previous

      this.summaryLoading = false
      this.detectionLoading = false
    },
    async updateCharts(reports, startDate, endDate, timeStep) {
      const eventCategories = this.getEventCategories()
      const seriesByEvent = {
        pass: [{ name: eventCategories[0].text, data: [] }],
        look: [{ name: eventCategories[1].text, data: [] }],
        interest: [{ name: eventCategories[2].text, data: [] }],
        focus: [{ name: eventCategories[3].text, data: [] }],
        touch: [{ name: eventCategories[4].text, data: [] }]
      }

      let maxNum = 5
      let timeStepLength = 0
      if (timeStep === 'hours') {
        timeStepLength = 1 * 60 * 60 * 1000

        for (const report of reports) {
          for (const key in report.data) {
            if (report.data[key] !== null) {
              if (maxNum < report.data[key].y) {
                maxNum = report.data[key].y
              }

              seriesByEvent[key][0].data.push(report.data[key])
            }
          }
        }
      } else if (timeStep === 'days') {
        timeStepLength = 24 * 60 * 60 * 1000

        const eventsByTime = {
          pass: {},
          look: {},
          interest: {},
          focus: {},
          touch: {}
        }
        for (const report of reports) {
          const reportDay = startOfDay(
            new Date(report.info.timestamp.seconds * 1000)
          ).getTime()

          for (const key in report.data) {
            if (report.data[key] !== null) {
              if (eventsByTime[key][reportDay]) {
                eventsByTime[key][reportDay] += report.data[key].y
              } else {
                eventsByTime[key][reportDay] = report.data[key].y
              }
            }
          }
        }

        for (const event in eventsByTime) {
          for (const time in eventsByTime[event]) {
            if (maxNum < eventsByTime[event][time]) {
              maxNum = eventsByTime[event][time]
            }
            seriesByEvent[event][0].data.push({
              x: Number(time),
              y: eventsByTime[event][time]
            })
          }
        }
      }

      const startUnixtime = startDate.getTime()
      const endUnixtime = endDate.getTime()

      const diffMilliSeconds = endUnixtime - startUnixtime
      let timeLineCount = parseInt(diffMilliSeconds / timeStepLength)
      const remainder = diffMilliSeconds % timeStepLength
      timeLineCount = remainder === 0 ? timeLineCount + 1 : timeLineCount + 2

      // Make time lines which has dates by time step from start date to end date.
      const timeLine = [startUnixtime]
      for (let i = 1; i < timeLineCount; i++) {
        const last = timeLine[i - 1]
        const current = last + timeStepLength

        if (i === timeLineCount - 1) {
          timeLine.push(endUnixtime)
        } else {
          timeLine.push(current)
        }
      }

      for (const key in seriesByEvent) {
        const series = []
        for (const time of timeLine) {
          const index = seriesByEvent[key][0].data.findIndex(
            d => d.x === Number(time)
          )
          if (index >= 0) {
            series.push(seriesByEvent[key][0].data[index].y)
          } else {
            series.push(0)
          }
        }

        series.pop()
        seriesByEvent[key][0].data = series
      }

      const xaxisCategory = xaxisCategories(timeStep, startDate, endDate)
      const stats = statsModel()
      for (const key in stats) {
        const category = eventCategories.find(k => k.value === key)
        stats[key].chart.options = {
          ...baseChartOptions(chartIds[key]),
          ...{
            selection: {
              enabled: true
            },
            colors: [category.color]
          }
        }
        stats[key].chart.options.yaxis.max = maxNum
        stats[key].chart.options.xaxis.categories = xaxisCategory
        stats[key].chart.series = seriesByEvent[key]
      }

      // Note: To make yaxis.max reactive, have to reload apexchart component.
      // Force reload apexchart component is not good way in SPA.
      // But couldn't find other way to do this.
      this.passChartKey += 1
      this.lookChartKey += 1
      this.interestChartKey += 1
      this.focusChartKey += 1
      this.touchChartKey += 1

      this.stats = stats

      detectionTimeLine.stepLength = timeStepLength
      detectionTimeLine.values = timeLine.slice(0, timeLine.length - 1)
    },
    async downloadDetectionReport() {
      this.downloading = true

      const startDate = this.filters.date.start
      const endDate = this.filters.date.end
      const diffDays = differenceInDays(endDate, startDate) + 1

      let timeline = []
      // Populate start and end date by day.
      for (let i = 0; i < diffDays; i++) {
        const start = addDays(startDate, i)
        const time = {
          start: start.toString(),
          end: endOfDay(start).toString()
        }
        timeline.push(time)
      }

      const files = []
      for (const deviceId of this.filters.devices) {
        for (const time of timeline) {
          const filename = `D_${deviceId}-${fmt(
            new Date(time.start),
            'yyyy-MM-dd'
          )}.json`

          try {
            const task = functions.httpsCallable(
              'report-DownloadDetectionReport'
            )
            // Create report file and get download url
            const result = await task({
              deviceId: deviceId,
              startDate: time.start,
              endDate: time.end
            })

            if (result.data.success) {
              files.push({ name: filename, url: result.data.url })
            }
          } catch (error) {
            this.showSnack({
              message: `${filename}のダウンロードに失敗しました`,
              color: 'error'
            })
            console.log(error)
          }
        }
      }

      if (files.length > 0) {
        const foldername = `時系列データ_${new Date()}`
        const zipBlob = await this.zipDownloadedFiles(
          foldername,
          files.map(f => f.url),
          10
        )

        if (zipBlob !== undefined && zipBlob !== null) {
          const urlObj = URL.createObjectURL(zipBlob)
          const anchor = this.downloadFile(foldername, urlObj)
          const message = `データをダウンロードしました`
          this.showSnack({ message })

          // Tidy up URL object to release memory.
          URL.revokeObjectURL(urlObj)
          // Tidy up anchor tags. sometime fail to download if removing anchor tag imidiatly,
          // so delete them here.
          anchor.remove()
        }
      }

      this.downloading = false
    }
  },
  watch: {
    filters() {
      if (
        this.filters.devices.length > 0 &&
        this.filters.date.start !== null &&
        this.filters.date.end !== null
      ) {
        this.summaryLoading = true
        this.detectionLoading = true

        this.updateReport(
          this.filters.devices,
          this.filters.date.start,
          this.filters.date.end
        )
      } else {
        // do something
      }
    }
  }
}
</script>

<style scoped>
.chart-container h1,
h3,
h4 {
  text-align: center;
  padding-top: 1%;
  padding-bottom: 1%;
}
.summary-description {
  font-size: 0.8em;
}

.detect-stats-row {
  display: flex;
  width: 100%;
}
.detect-stats-icon {
  min-width: 80px;
  flex-grow: 1;
  text-align: center;
}
.detect-stats-summary {
  min-width: 140px;
  flex-grow: 2;
}
.detect-stats-chart {
  flex-grow: 6;
  width: 100%;
}
</style>
